import { styled, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AssistantGenerateRoutesDialogPreAsignedDriverActionButton = styled(
  Button,
)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(13),
  padding: '1px 10px',
  height: 30,
}));

export const AssistantGenerateRoutesDialogPreAsignedDriverActionIcon = styled(
  FontAwesomeIcon,
)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(13),
}));

export const AssistantGenerateRoutesDialogPreAsignedDriverActionIconButton =
  styled(Button)(({ theme }) => ({
    minWidth: 30,
    height: 30,
    padding: theme.spacing(0, 1.5),
  }));
